import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from './guards';
import { dashboardRoutes } from './routes/dashboardRoutes';
import { profileRoutes } from './routes/profileRoutes';
import { clientEmployeeRoutes } from './routes/clientEmployeeRoutes';
import { payrollRoutes } from './routes/payrollRoutes';
import { hoursRoutes } from './routes/hoursRoutes';
import { reportsRoutes } from './routes/reportsRoutes';
import { placeholderRoutes } from './routes/placeholderRoutes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...dashboardRoutes,
    ...clientEmployeeRoutes,
    ...reportsRoutes,
    ...profileRoutes,
    ...payrollRoutes,
    ...hoursRoutes,
    ...placeholderRoutes,
  ],
});

router.beforeEach(authGuard);

export default router;
